import Icon from "@portal/components/atoms/icons";
import Illustration from "@portal/components/atoms/illustrations";

export const GetIconForPlanningPage = (index: number) => {
  const size = "xxlarge";
  if (index === 0)
    return (
      <div className="p-3">
        <Icon name={"piggyBankIcon"} size="large" />
      </div>
    );
  if (index === 1) return <Illustration name={"coupleWithVespaIcon"} size={size} />;
  if (index === 2) return <Illustration name={"womanWithGoalsYellowIcon"} size={size} />;
  if (index === 3) return <Illustration name={"manWithGraphsYellowIcon"} size={size} />;
  if (index === 4) return <Illustration name={"manWithCheckboxesBlueIcon"} size={size} />;
};
